import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import i18n from 'src/i18n';
import ActionModal from 'src/components/ActionModal';
import ActionModalAlertContainer from 'src/components/ActionModal/components/ActionModalAlertContainer';
import ActionModalDetailWarning from 'src/components/ActionModal/components/ActionModalDetailWarning';
import ActionModalFooter from 'src/components/ActionModal/components/ActionModalFooter';
import DeleteLandModalViewModel from './viewModel';
import styles from './styles.module.scss';

@observer
class DeleteLandModal extends React.Component {
  constructor(props) {
    super(props);
    this.vm = props.vm;
  }

  render() {
    return (
      <ActionModal vm={this.vm.modalVM} width={375} onCancel={this.vm.close}>
        <ActionModalAlertContainer>
          <ActionModalDetailWarning
            title={this.vm.title}
            content={this.vm.content}
          />

          <ActionModalFooter
            cancelProps={{
              onClick: this.vm.close,
              children: i18n.t('delete_land_modal_cancel_button_label')
            }}
            confirmProps={{
              onClick: this.vm.onConfirm,
              disabled: this.vm.disabled.confirm,
              children: i18n.t('delete_land_modal_confirm_button_label'),
              danger: true
            }}
          />
        </ActionModalAlertContainer>
      </ActionModal>
    );
  }
}

DeleteLandModal.propTypes = {
  vm: PropTypes.object.isRequired
};

DeleteLandModal.defaultProps = {};

export default DeleteLandModal;
